export default "__VITE_ASSET__BsXM_mdV__"